export default __webpack_public_path__ + "static/media/form-validation-password-complete.78ca946d.png";